import {
	getProductsSuccess,
	wishlistItemSuccess as wishlistProductSuccess,
	requestStart as productsRequestStart,
	requestFailure as productsRequestFailure,
} from '../product/products';
import {
	getProductCardSuccess,
	wishlistItemSuccess as wishlistProductCardSuccess,
	requestStart as productCardRequestStart,
	requestFailure as productCardRequestFailure,
} from '../product/productcard';
import {
	getProductsSuccess as getProductSearchSuccess,
	wishlistItemSuccess as wishlistSearchProductSuccess,
	requestStart as productSearchResultsRequestStart,
	requestFailure as productSearchResultsRequestFailure,
} from './../search/productsearchresults';
import {
	getSuccess as getYouMayAlsoLikeProductsSuccess,
	wishlistItemSuccess as wishlistYouMayAlsoLikeProductCardSuccess,
	requestStart as youMayAlsoLikeProductsRequestStart,
	requestFailure as youMayAlsoLikeProductsRequestFailure,
} from './../product/youmayalsolike';
import {
	setArticleFeaturedProducts,
	wishlistItemSuccess as wishlistArticleFeaturedProductSuccess,
	requestStart as articleCardRequestStart,
	requestFailure as articleCardRequestFailure,
} from '../magazine/article/articlecard';
import {
	getWardrobeItemsSuccess,
	wishlistItemSuccess as wishlistSearchWardrobeItemSuccess,
	requestStart as wardrobeItemSearchResultsRequestStart,
	requestFailure as wardrobeItemResultsRequestFailure,
} from './../search/wardrobeitemsearchresults';
import {
	getWishlistSuccess,
	wishlistItemSuccess as wishlistWishlistItemSuccess,
	requestStart as wishlistItemRequestStart,
	requestFailure as wishlistItemRequestFailure,
} from './../user/wishlist';

import { IStore } from 'redux/IStore';
import { IWishlistedItem, IEntityDto } from 'models/common';
import { actions as notifActions } from 'redux-notifications';
import { NodeType } from 'models/enums/nodetype/nodetype';
import { WishlistNodeType } from 'models/enums/nodetype/wishlistnodetype';
import * as i18n from 'i18next';
import { accessTokenIsPresent } from 'containers/AccessControl/helpers';

const { notifSend } = notifActions;

export class Wishlists {
	private wishlistNodeType: WishlistNodeType;
	private nodeType: NodeType;
	private wishlistItemSuccess: () => void;
	private requestStart: () => void;
	private requestFailure: (message: any) => void;
	private updateItemsSuccess: (items: any) => void;

	constructor(wishlistNodeType: WishlistNodeType) {
		this.wishlistNodeType = wishlistNodeType;

		switch (this.wishlistNodeType) {
			case WishlistNodeType.Product:
				this.wishlistItemSuccess = wishlistProductSuccess;
				this.requestStart = productsRequestStart;
				this.requestFailure = productsRequestFailure;
				this.updateItemsSuccess = getProductsSuccess;
				this.nodeType = NodeType.Product;
				break;
			case WishlistNodeType.ProductCard:
				this.wishlistItemSuccess = wishlistProductCardSuccess;
				this.requestStart = productCardRequestStart;
				this.requestFailure = productCardRequestFailure;
				this.updateItemsSuccess = getProductCardSuccess;
				this.nodeType = NodeType.Product;
				break;
			case WishlistNodeType.ProductSearch:
				this.wishlistItemSuccess = wishlistSearchProductSuccess;
				this.requestStart = productSearchResultsRequestStart;
				this.requestFailure = productSearchResultsRequestFailure;
				this.updateItemsSuccess = getProductSearchSuccess;
				this.nodeType = NodeType.Product;
				break;
			case WishlistNodeType.ProductsYouMayAlsoLike:
				this.wishlistItemSuccess = wishlistYouMayAlsoLikeProductCardSuccess;
				this.requestStart = youMayAlsoLikeProductsRequestStart;
				this.requestFailure = youMayAlsoLikeProductsRequestFailure;
				this.updateItemsSuccess = getYouMayAlsoLikeProductsSuccess;
				this.nodeType = NodeType.Product;
				break;
			case WishlistNodeType.ArticleFeaturedProducts:
				this.wishlistItemSuccess = wishlistArticleFeaturedProductSuccess;
				this.requestStart = articleCardRequestStart;
				this.requestFailure = articleCardRequestFailure;
				this.updateItemsSuccess = setArticleFeaturedProducts;
				this.nodeType = NodeType.Product;
				break;
			case WishlistNodeType.WardrobeItemSearch:
				this.wishlistItemSuccess = wishlistSearchWardrobeItemSuccess;
				this.requestStart = wardrobeItemSearchResultsRequestStart;
				this.requestFailure = wardrobeItemResultsRequestFailure;
				this.updateItemsSuccess = getWardrobeItemsSuccess;
				this.nodeType = NodeType.WardrobeItem;
				break;
			case WishlistNodeType.Wishlist:
				this.wishlistItemSuccess = wishlistWishlistItemSuccess;
				this.requestStart = wishlistItemRequestStart;
				this.requestFailure = wishlistItemRequestFailure;
				this.updateItemsSuccess = getWishlistSuccess;
				break;
			default:
		}
	}

	public updateWishlistItems(wishlistedItems?: any) {
		return (dispatch, getState: () => IStore) => {
			// update array of items
			if (this.isArrayNode()) {
				this.updateArrayOfItems(wishlistedItems, getState(), dispatch);
				// update object
			} else {
				this.updateObject(wishlistedItems, getState(), dispatch);
			}
		};
	}

	public wishlist(itemId: string, nodeType?: NodeType) {
		return (dispatch, getState: () => IStore) => {
			dispatch(this.requestStart());

			let type = this.nodeType;
			if (nodeType) {
				type = nodeType;
			}
			dispatch(this.updateWishlistedItem(itemId, undefined));

			return fetch(
				getState().fetchDefault.baseAPI + 'api/' + NodeType[type] + '/' + itemId + '/Wishlist',
				Object.assign({}, getState().fetchDefault.requestInit, {
					method: 'POST',
				}),
			)
				.then((res) => {
					if (res.ok || res.status === 409) {
						dispatch(this.wishlistItemSuccess());
						dispatch(this.updateWishlistedItem(itemId, true));
						if (type === NodeType.Product) {
							dispatch(
								notifSend({
									message: i18n.t('Notification_Success_Wishlisted_Product'),
									kind: 'success',
									dismissAfter: 3000,
								}),
							);
						} else {
							dispatch(
								notifSend({
									message: i18n.t('Notification_Success_Wishlisted_WardrobeItem'),
									kind: 'success',
									dismissAfter: 3000,
								}),
							);
						}
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(this.requestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(this.requestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(this.requestFailure(err));
				});
		};
	}

	public unwish(itemId: string, nodeType?: NodeType) {
		return (dispatch, getState: () => IStore) => {
			dispatch(this.requestStart());

			let type = this.nodeType;
			if (nodeType) {
				type = nodeType;
			}
			dispatch(this.updateWishlistedItem(itemId, undefined));

			return fetch(
				getState().fetchDefault.baseAPI + 'api/' + NodeType[type] + '/' + itemId + '/Wishlist',
				Object.assign({}, getState().fetchDefault.requestInit, {
					method: 'DELETE',
				}),
			)
				.then((res) => {
					if (res.ok || res.status === 409) {
						dispatch(this.wishlistItemSuccess());
						// remove item if we have list of wishlisted items, otherwise just update it
						if (this.wishlistNodeType === WishlistNodeType.Wishlist) {
							dispatch(this.removeWishlistedItem(itemId));
						} else {
							dispatch(this.updateWishlistedItem(itemId, false));
						}
						if (type === NodeType.Product) {
							dispatch(
								notifSend({
									message: i18n.t('Notification_Success_Unwished_Product'),
									kind: 'success',
									dismissAfter: 3000,
								}),
							);
						} else {
							dispatch(
								notifSend({
									message: i18n.t('Notification_Success_Unwished_WardrobeItem'),
									kind: 'success',
									dismissAfter: 3000,
								}),
							);
						}
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(this.requestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(this.requestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(this.requestFailure(err));
				});
		};
	}

	public getWishlistedItems() {
		return (dispatch, getState: () => IStore) => {
			if (!accessTokenIsPresent()) {
				return Promise.resolve(false);
			}

			dispatch(this.requestStart());

			const data = this.getNodeItems(getState());
			let itemsToGet = null;

			if (this.isArrayNode()) {
				const items: IEntityDto[] = data.map((item) => {
					return {
						entityId: item.entityId,
					};
				});
				itemsToGet = JSON.stringify(items);
			} else {
				itemsToGet = JSON.stringify([{ entityId: data.entityId }]);
			}

			return fetch(
				getState().fetchDefault.baseAPI + 'api/User/IsWishlist',
				Object.assign({}, getState().fetchDefault.requestInit, {
					method: 'POST',
					body: itemsToGet,
				}),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => {
							if (this.isArrayNode()) {
								dispatch(this.updateWishlistItems(res));
							} else {
								dispatch(this.updateWishlistItems(res[0]));
							}
						});
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(this.requestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(this.requestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(this.requestFailure(err));
				});
		};
	}

	private updateWishlistedItem(itemId: string, isAdded: boolean | undefined) {
		return (dispatch, getState: () => IStore) => {
			const data = this.getNodeItems(getState());
			if (!data) {
				return;
			}

			// update array of items
			if (this.isArrayNode()) {
				const itemInList: any = data.filter((x) => x.id === itemId)[0];
				const itemIndex = data.indexOf(itemInList);
				if (itemIndex > -1) {
					data[itemIndex].isWishlisted = isAdded;
					dispatch(this.updateItemsSuccess(data));
				}
				// update object
			} else {
				data.isWishlisted = isAdded;
				dispatch(this.updateItemsSuccess(data));
			}
		};
	}

	private removeWishlistedItem(itemId: string) {
		return (dispatch, getState: () => IStore) => {
			const data = this.getNodeItems(getState());
			if (!data) {
				return;
			}

			if (this.isArrayNode()) {
				const itemInList: any = data.filter((x) => x.id === itemId)[0];
				const itemIndex = data.indexOf(itemInList);
				if (itemIndex > -1) {
					data.splice(itemIndex, 1);
					dispatch(this.updateItemsSuccess(data));
				}
			}
		};
	}

	private updateArrayOfItems(wishlistedItems: IWishlistedItem[], state: IStore, dispatch: any) {
		const data: any[] = this.getNodeItems(state);
		if (wishlistedItems !== null) {
			wishlistedItems.forEach((wishlistItem: IWishlistedItem) => {
				const item: any = data.filter((i) => i.id === JSON.parse(wishlistItem.key.entityId).id)[0];
				if (!item) {
					return;
				}
				const itemIndex = data.indexOf(item);
				item.isWishlisted = wishlistItem.value;
				data[itemIndex] = item;
			});
		} else {
			data.map((item) => {
				item.isWishlisted = false;
			});
		}
		dispatch(this.updateItemsSuccess(data));
	}

	private updateObject(wishlistedItem: IWishlistedItem, state: IStore, dispatch: any) {
		const data: any = this.getNodeItems(state);
		if (!data) {
			return;
		}
		if (wishlistedItem !== null) {
			if (data.id === JSON.parse(wishlistedItem.key.entityId).id) {
				data.isWishlisted = wishlistedItem.value;
			}
		} else {
			data.isWishlisted = false;
		}
		dispatch(this.updateItemsSuccess(data));
	}

	private isArrayNode(): boolean {
		if (
			this.wishlistNodeType === WishlistNodeType.ProductSearch ||
			this.wishlistNodeType === WishlistNodeType.Product ||
			this.wishlistNodeType === WishlistNodeType.ProductsYouMayAlsoLike ||
			this.wishlistNodeType === WishlistNodeType.ArticleFeaturedProducts ||
			this.wishlistNodeType === WishlistNodeType.WardrobeItemSearch ||
			this.wishlistNodeType === WishlistNodeType.Wishlist
		) {
			return true;
		} else {
			return false;
		}
	}

	private getNodeItems(state: IStore) {
		let data = null;
		if (this.wishlistNodeType === WishlistNodeType.Product) {
			data = state.products.items;
		} else if (this.wishlistNodeType === WishlistNodeType.ProductCard) {
			data = state.productCard.productCard;
		} else if (this.wishlistNodeType === WishlistNodeType.ProductSearch) {
			data = state.productSearchResults.items;
		} else if (this.wishlistNodeType === WishlistNodeType.ProductsYouMayAlsoLike) {
			data = state.youMayAlsoLikeProducts.items;
		} else if (this.wishlistNodeType === WishlistNodeType.ArticleFeaturedProducts) {
			data = state.articleCard.item.itemsJArray;
		} else if (this.wishlistNodeType === WishlistNodeType.WardrobeItemSearch) {
			data = state.wardrobeItemSearchResults.items;
		} else if (this.wishlistNodeType === WishlistNodeType.Wishlist) {
			data = state.wishlist.items;
		}
		return data;
	}
}
